import { efaAddToCart } from './add-to-cart-de.i18n';

export const de = {
  efaAddToCart
};
